import {neverland as $, html} from 'neverland';
import { pendingApprovalView, pendingApprovalLogout } from '../lib/pendingApproval.js';

/**
 * ST4S phase 3 (design §6.3): pending-approval screen.
 *
 * Shown to a subsequent (non-first) registrant whose users[] entry was written
 * status:'pending'. They are NOT logged in (mfaVerified is never set) so no
 * data session loads; they wait for the organisation's contact person to
 * approve the request. The only action here is to log out / go back, which
 * clears the pending auth state.
 */
const PendingApprovalPage = $(function(auth, setAuth, theme) {
  function getLogo() {
    if (theme && theme.logo && theme.logo !== '') {
      return '/static/img/logos-large/' + theme.logo;
    }
    return '/static/img/transparent-placeholder.png';
  }

  function logout() {
    setAuth(pendingApprovalLogout);
  }

  const { school, contactEmails, helpdeskEmail } = pendingApprovalView(auth);

  const contactLine = contactEmails.length > 0
    ? html`
        <p style="margin-bottom: 15px; font-size: 1em; opacity: 0.8;">
          Your access request for <strong>${school}</strong> is awaiting approval from
          your organisation's contact: <strong>${contactEmails.join(', ')}</strong>.
          Please reach out to them, or contact
          <a href="mailto:${helpdeskEmail}">${helpdeskEmail}</a> if you need help.
        </p>
      `
    : html`
        <p style="margin-bottom: 15px; font-size: 1em; opacity: 0.8;">
          Your access request for <strong>${school}</strong> is awaiting approval from
          your organisation's contact. Please contact
          <a href="mailto:${helpdeskEmail}">${helpdeskEmail}</a> if you need help.
        </p>
      `;

  return html`
    <div class="centre-box login">
      <img src="${getLogo()}" class="squiggle logo-large" />

      <div id="login">
        <h2 style="margin-bottom: 10px; font-size: 1.2em;">Access Pending Approval</h2>
        ${contactLine}
        <p style="margin-bottom: 15px; font-size: 1em; opacity: 0.8;">
          You'll be able to sign in once your request has been approved.
        </p>

        <button class="back-link" onclick=${logout}>
          &larr; Back to Login
        </button>
      </div>
    </div>
  `;
});

export default PendingApprovalPage;
